
import { Toaster } from 'sonner';

export function AdminLoginToaster() {
  return (
    <Toaster
      theme="dark"
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            'font-inter rounded-xl border border-white/10 bg-[#0b1428]/95 text-slate-100 shadow-xl shadow-black/40 backdrop-blur-xl',
          title: 'font-poppins text-sm font-semibold',
          description: 'text-slate-400',
        },
      }}
    />
  );
}
